import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import DatePicker from "react-datepicker";
import { storage } from "../../firebase.config";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { IoIosCloseCircle } from "react-icons/io";
import moment from "moment";
import { arrayUnion, increment } from "firebase/firestore";
import { updateItem } from "../../utils/firebasefunctions";
import { ToastContainer, toast } from "react-toastify";
import { useStateValue } from "../context/StateProvider";
import { RotatingLines } from "react-loader-spinner";

const UploadPaymentPopUp = (props) => {
  const [fromdate, setfromdate] = useState(new Date());
  const [todate, settodate] = useState(new Date());
  const [imagedata, setimagedata] = useState("");
  const [imageurl, setimageurl] = useState("");
  const [leaves, setleaves] = useState(0);
  const [payslipuploadloader, setpayslipuploadloader] = useState(false);
  const fileInput = useRef();

  const [{ user }, dispatch] = useStateValue();

  const handleimageChange = (event) => {
    fileInput.current.click();
  };

  const handleimageselected = (e) => {
    setimagedata(e);
    // setimageurl(
    //   `${URL.createObjectURL(e.target.files[0])}#page=1&${Date.now()}`
    // );

    setimageurl(URL.createObjectURL(e.target.files[0]));
  };

  async function uploadpaymentslip() {
    if (todate < fromdate) {
      toast.warn("To date can not be lesser than from date!");
    } else if (imagedata == "") {
      toast.warn("Please upload a payment slip!");
    } else {
      setpayslipuploadloader(true);
      let data = {
        todate: moment(fromdate).format("YYYY-MM-DD"),
        fromdate: moment(todate).format("YYYY-MM-DD"),
        uploadedby: user.id,
        createdat: Date.now(),
      };

      const imageFile = imagedata.target.files[0];
      const storageRef = ref(
        storage,
        `paymentslips/${Date.now()}-${imageFile.name}`
      );
      const uploadTask = uploadBytesResumable(storageRef, imageFile);
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          toast.error("upload error " + error.message);
          setpayslipuploadloader(false);
        },
        async () => {
          await getDownloadURL(uploadTask.snapshot.ref)
            .then(async (downloadURL) => {
              data["paymentslip"] = downloadURL;

              let taskdata = {
                employeepayments: arrayUnion(data),
              };

              await updateItem("PaymentSlips", props.id, taskdata)
                .then(async (response) => {
                  let newleaves = {
                    leaves: increment(leaves),
                  };
                  await updateItem("users", props.id, newleaves)
                    .then(async (response) => {
                      setimagedata("");
                      setimageurl("");

                      settodate(new Date());
                      setfromdate(new Date());
                      setleaves(0);
                      setpayslipuploadloader(false);
                      props.cancel();
                      toast.success("Payment Slip Uploaded Successfully");
                    })
                    .catch((err) => {
                      alert(err);
                      setpayslipuploadloader(false);
                    });
                })
                .catch((err) => {
                  alert(err);
                  setpayslipuploadloader(false);
                });
            })
            .catch((error) => {
              toast.error(error.message);
              setpayslipuploadloader(false);
            });
        }
      );
    }
  }

  const preview = () => {
    return (
      <div className="flex w-full justify-center mt-[20px]">
        <div className="flex relative w-[200px] h-[270px]">
          <div
            onClick={() => {
              setimagedata("");
              setimageurl("");
            }}
            className="bg-themeColor h-[25px] w-[25px]  rounded-full flex  items-center justify-center position absolute right-[-5px] top-[-5px]"
          >
            <IoIosCloseCircle className=" text-white  w-[15px] h-[15px] hover:cursor-pointer" />
          </div>
          {/* <p className=" PoppinsRegular  text-black text-[12px] text-center">
                  {imageurl.toString()}
                </p> */}

          <iframe
            src={imageurl + "#page=1"}
            width="200"
            height="270"
            style={{
              border: "none",
              overflow: "hidden",
              display: "block",
            }}
          />
        </div>
      </div>
    );
  };

  const handleChange = (e) => {
    const val = e.target.value;
    // Allow empty input
    if (val === "") return setleaves("");
    // Regex: match whole or half step (e.g., 1, 1.5, 10.5)
    if (/^\d+(\.5)?$/.test(val)) {
      setleaves(val);
    }
  };
  return (
    props.visible && (
      <div className="position absolute z-10  top-[0] left-[0] w-full h-full bg-[rgba(211,211,211,0.2)] flex items-center justify-center">
        <div
          className="w-[80%] md:w-[500px]   bg-themeColor border border-white/20 rounded-lg  gk-scr p-[20px]  flex items-center justify-center flex-col"
          style={props.style}
        >
          {props.picture && (
            <img loading="lazy"
              src={props.picture}
              className="w-[120px] h-[120px] rounded-full object-cover  bg-cardOverlay  drop-shadow-lg mb-[15px]"
            />
          )}

          <div className="w-[90%] lg:w-[95%] mx-auto flex flex-row flex-wrap justify-between items-center">
            <div className="w-full lg:w-[48%] mt-4 lg:mt-0">
              <p className="PoppinsRegular  text-white/80 text-sm pb-1">From</p>
              <DatePicker
                className="input PoppinsRegular  border border-white/20 rounded-xl w-full bg-themelightblack text-white"
                selected={fromdate}
                onChange={(date) => {
                  setfromdate(date);
                }}
              />
            </div>
            <div className="w-full lg:w-[48%] mt-4 lg:mt-0">
              <p className="PoppinsRegular  text-white/80 text-sm pb-1">To</p>
              <DatePicker
                className="input PoppinsRegular  border border-white/20 bg-themelightblack text-white rounded-xl w-full"
                selected={todate}
                minDate={fromdate}
                onChange={(date) => {
                  settodate(date);
                }}
              />
            </div>
          </div>

          <div className="w-[90%] lg:w-[95%] mx-auto flex flex-row flex-wrap justify-between items-center">
            <div className="w-full  mt-4 ">
              <p className="PoppinsRegular  text-white/80 text-sm pb-1">
                Availed leaves
              </p>

              <input
                type="number"
                step="0.5"
                min="0"
                value={leaves}
                onChange={handleChange}
                className="input PoppinsRegular  border border-white/20 bg-themelightblack text-white rounded-xl w-full"
                placeholder="Enter leaves.."
              />
            </div>
          </div>
          {imageurl != "" && preview()}

          <div
            onClick={handleimageChange}
            className={`rounded-md w-[150px] h-[35px] bg-themeblue flex items-center justify-center hover:cursor-pointer mt-[20px]`}
          >
            <p className=" PoppinsRegular  text-white text-[12px] text-center">
              Add Payment Slip
            </p>
          </div>

          <input
            type="file"
            style={{ display: "none" }}
            ref={fileInput}
            accept="application/pdf"
            onChange={handleimageselected}
          />

          {payslipuploadloader ? (
            <div className=" py-4   w-full flex justify-center   mt-[20px]">
              <RotatingLines
                visible={true}
                height="25"
                width="25"
                color="grey"
                strokeColor="#00C763"
                strokeWidth="5"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <div className="flex w-full justify-between items-center flex-row mt-[20px]">
              <button
                onClick={() => {
                  uploadpaymentslip();
                }}
                type="submit"
                className="text-center py-2 rounded-md  bg-themeblue hover:bg-themeblue/80 w-[45%]  mx-auto text-white text-sm  PoppinsRegular uppercase"
              >
                Upload
              </button>
              <button
                onClick={() => {
                  props.cancel();
                }}
                type="submit"
                className="text-center py-2 rounded-md  bg-lighttextGray hover:bg-lighttextGray/80 w-[45%]  mx-auto text-white text-sm  PoppinsRegular uppercase"
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default UploadPaymentPopUp;
